import { decryptState } from "shared/encryptInfo";
import { APIClient } from "../api_helper";
import {
  PUBLIC_POST_CREATE_USER,
  POST_FORGOT_PASSWORD,
  POST_LOGIN_USER,
  POST_OPT_VERIFIED_LOGIN,
  POST_RESET_PASSWORD,
  REFRESH_TOKEN,
  RESEND_OTP,
  PIBLIC_POST_ENTITY_DATA,
  PUBLIC_CREATE_ENTITY_USER,
  POST_VERIFY_EMAIL,
  SAVE_INDIVIDUAL_FIST_STEP,
  VALIDATE_INDIVIDUAL_OTP,
  SEND_INDIVIDUAL_OPT_VERIFICATION,
  CHECK_REGISTER_PROGRESS,
  CONTINUE_REGISTER_PROGRESS,
  POST_IDENTITY_VERIFIFCATION,
  POST_ADDRESS_INFORMATION,
  POST_FINANCIAL_INFORMATION,
  GET_REGISTER_ENDED,
  POST_SUBMIT_REGISTER,
  POST_COMPANY_FIRST_STEP,
  GET_DOCUMENTS_TYPES,
  POST_BUSINESS_INFORMATION,
  GET_COMPANTY_TYPE,
  POST_LEGAL_DOCUMENTS,
  POST_SHARE_HOLDERS,
  GET_INCOME_RANGES,
  GET_FUNDS_TYPE,
  POST_COMPANY_FINANTIAL_INFO,
  GET_COMPANY_FINAL_INFO,
  POST_SUBMIT_BUSINESS_REGISTER,
  GET_ECONOMIC_ACTIVITIES,
  SAVE_IMAGES,
  SAVE_PDF,
  UPLOAD_CHUNK,
  COMPLETE_UPLOAD,
  UPLOAD_PDF,
} from "../url_helper";

const api = new APIClient();

export const loginUserBackend = async (data: any) =>
  api.post(POST_LOGIN_USER, data);

export const verifyOtpCode = async (data: any) =>
  api.post(POST_OPT_VERIFIED_LOGIN, data);

export const forgotPassword = async (data: any) =>
  api.post(POST_FORGOT_PASSWORD, data);

export const resetPassword = async (data: any) =>
  api.post(POST_RESET_PASSWORD, data);

export const createUser = async (data: any) =>
  api.create(PUBLIC_POST_CREATE_USER, data);

export const postEntityData = async (data: any) =>
  api.post(PIBLIC_POST_ENTITY_DATA, data);

export const postEntityUserData = async (data: any) =>
  api.post(PUBLIC_CREATE_ENTITY_USER, data);

export const refreshToken = async () => {
  // Se agregara el refresh token en esta seccion
  const response: any = localStorage.getItem("refreshToken");
  // console.log("Token Actual: " + response);
  if (!response) return 0;

  const refreshTokenDecrypted = decryptState(response);
  // console.log("Token Desencriptado: " + refreshTokenDecrypted);
  const responseNewToken: any = await api.post(REFRESH_TOKEN, {
    refreshToken: refreshTokenDecrypted,
  });
  // console.log("Nuevo token de acceso: " + responseNewToken.accessToken);
  localStorage.setItem("authUser", responseNewToken.accessToken);
  // scheduleTokenRefresh(responseNewToken.accessToken);
};

//Agendar refresco de token
export function scheduleTokenRefresh(accessToken) {
  if (!accessToken) return;
  // console.log("accessToken: " + accessToken);
  // Decodificar el JWT (solo la parte payload) y extraer `exp`
  const payload = JSON.parse(atob(accessToken.split(".")[1]));
  const expirationTime = payload.exp * 1000; // en milisegundos
  const now = Date.now();
  const refreshTime = expirationTime - now - 20000; // restamos 30s
  if (refreshTime > 0) {
    setTimeout(async () => {
      await refreshToken(); // Llamas tu función de refresh
      // Una vez renovado el token, volvemos a programar el siguiente refresh
      const newToken = localStorage.getItem("authUser");
      // console.log("Nuevo Token: " + newToken);
      scheduleTokenRefresh(newToken);
    }, refreshTime);
  }
}

export const resend_otp = async (data: any) => api.post(RESEND_OTP, data);

export const verfify_email = async (data: any) =>
  api.post(POST_VERIFY_EMAIL, { token: data });

// -------------------------------------------------------
//NUEVO FORMATO PARA LOS REGISTROS DE USUARIO HE ENTIDADES
export const registerIndividualFistStep = async (data: any) =>
  api.post(SAVE_INDIVIDUAL_FIST_STEP, data);

export const sendIndividualOTPVerification = async (data: any) =>
  api.post(SEND_INDIVIDUAL_OPT_VERIFICATION, data);

export const validateIndividualOTP = async (data: any) =>
  api.post(VALIDATE_INDIVIDUAL_OTP, data);

export const checkRegisterProgress = async (data: any) =>
  api.post(CHECK_REGISTER_PROGRESS, data);

export const continueRegisterProgress = async (data: any) =>
  api.post(CONTINUE_REGISTER_PROGRESS, data);

export const postIdentityVerification = async (data: any) =>
  api.post(POST_IDENTITY_VERIFIFCATION, data);

export const postAddressInformation = async (data: any) =>
  api.post(POST_ADDRESS_INFORMATION, data);

export const postFinancialInformation = async (data: any) =>
  api.post(POST_FINANCIAL_INFORMATION, data);

export const getRegisterEnded = async (userId: any) =>
  api.get(`${GET_REGISTER_ENDED}?userId=${userId}`, null);

export const submitRegister = async (data: any) =>
  api.post(POST_SUBMIT_REGISTER, data);

export const getDocumentsTypes = async () => api.get(GET_DOCUMENTS_TYPES, null);

export const saveImages = async (data: any) => api.post(SAVE_IMAGES, data);
export const uploadPDF = async (data: any) => api.post(UPLOAD_PDF, data);
export const savePDF = async (data: any) => api.post(SAVE_PDF, data);
export const uploadChunk = async (data: any) => api.post(UPLOAD_CHUNK, data);
export const completeUpload = async (data: any) =>
  api.post(COMPLETE_UPLOAD, data);

//-- COMPANY FIRST STEP --//
export const getCompanyType = async () => api.get(GET_COMPANTY_TYPE, null);

export const getIncomeRanges = async () => api.get(GET_INCOME_RANGES, null);

export const getFundsType = async (id: any) =>
  api.get(`${GET_FUNDS_TYPE}?entity_type=${id}`, null);

export const getEconomicActivitiesPublic = async () =>
  api.get(GET_ECONOMIC_ACTIVITIES, null);

export const postCompanyFistStep = async (data: any) =>
  api.post(POST_COMPANY_FIRST_STEP, data);

export const postBussinessInformation = async (data: any) =>
  api.post(POST_BUSINESS_INFORMATION, data);

export const postLegalDocuments = async (data: any) =>
  api.post(POST_LEGAL_DOCUMENTS, data);

export const postShareHolders = async (data: any) =>
  api.post(POST_SHARE_HOLDERS, data);

export const postCompanyFinantialInfo = async (data: any) =>
  api.post(POST_COMPANY_FINANTIAL_INFO, data);

export const getCompanyFinalInfo = async (userId: number) =>
  api.get(`${GET_COMPANY_FINAL_INFO}?userId=${userId}`, null);

export const postSubimitBusinessRegister = async (data: any) =>
  api.post(`${POST_SUBMIT_BUSINESS_REGISTER}`, data);
